import { Box, ButtonGroup, IconButton, Typography } from "@mui/material";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import React from "react";

interface ZoomControlsProps {
  setZoom: (value: ((prevState: number) => number) | number) => void;
}

export function ZoomControls(props: ZoomControlsProps) {
  return (
    <Box className="horizontal-flex">
      <Typography variant="subtitle1">Zoom:&nbsp;</Typography>
      <ButtonGroup variant="contained" aria-label="outlined secondary button group">
        <IconButton color="primary" aria-label="Zoom-in" onClick={() => props.setZoom((z) => z * 1.5)}>
          <ZoomInIcon />
        </IconButton>
        <IconButton color="primary" aria-label="Zoom-out" onClick={() => props.setZoom((z) => z / 1.5)}>
          <ZoomOutIcon />
        </IconButton>
      </ButtonGroup>
    </Box>
  );
}
